import { render, staticRenderFns } from "./DomainConfiguration.vue?vue&type=template&id=9b79d144&scoped=true"
import script from "./DomainConfiguration.vue?vue&type=script&lang=js"
export * from "./DomainConfiguration.vue?vue&type=script&lang=js"
import style0 from "./DomainConfiguration.vue?vue&type=style&index=0&id=9b79d144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b79d144",
  null
  
)

export default component.exports